import { certboxConstants, sentConstants } from '../../constants'

const initialState = {
  certboxList: {},
  certboxOrgList: {},
  certboxReadingList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  isSubmission: false,
  isUpload: false,
  isSubDoc: false,
  isReceive: false,
  isReading: false,
  showPwdPopup: false,
  receiverList: [],
  pcrlInfo: {},
  crtfInfo: {},
  readingInfo: {},
  isToken: false,
  tokenInfo: {},
  isCheckedDownloading: false,
}

export default function certbox(state = initialState, action) {
  switch (action.type) {
    /***********
     수신함 검색조건 변경
     ************/
    case certboxConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload,
      }

    /*********
     수신함 목록 조회
     **********/
    case certboxConstants.CERTBOX_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.CERTBOX_SUCCESS:
      return {
        ...state,
        certboxList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case certboxConstants.CERTBOX_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     수신함 원본 목록 조회
     **********/
    case certboxConstants.CERTBOX_ORG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.CERTBOX_ORG_SUCCESS:
      return {
        ...state,
        certboxOrgList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case certboxConstants.CERTBOX_ORG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     수신함 1회열람 조회
     **********/
    case certboxConstants.CERTBOX_READING_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.CERTBOX_READING_SUCCESS:
      return {
        ...state,
        certboxReadingList: action.response.data?.payload,
        isReading: false,
        showPwdPopup: false,
      }
    case certboxConstants.CERTBOX_READING_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     증명서 삭제
     **********/
    case certboxConstants.DELETE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    case certboxConstants.DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isDelete: false,
      }

    /***********
     수신함 증명서 상세 선택
     ************/
    case certboxConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload,
      }

    /*********
     수신함 증명서 상세 조회
     **********/
    case certboxConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.DETAIL_SUCCESS:
      return {
        ...state,
        certboxInfo: action.response.data?.payload,
        isFailure: false,
      }
    case certboxConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /***********
     증명서 제출 수신자 SELECT 팝업 오픈
     ************/
    case certboxConstants.OPEN_RECEIVER_REQUEST:
      return {
        ...state,
        target: action.payload,
      }

    /***********
     증명서 제출 수신자 추가
     ************/
    case certboxConstants.ADD_RECEIVER_REQUEST:
      return {
        ...state,
        receiver: action.payload,
      }

    /***********
     증명서 제출 첨부문서 row 최신화
     ************/
    case certboxConstants.CHANGE_FILE_REQUEST:
      return {
        ...state,
        fileList: action.payload,
      }

    /*********
     최근 보낸 주소 조회
     **********/
    case certboxConstants.SELECT_RECENT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.SELECT_RECENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        receiverList: action.response.data?.payload,
      }
    case certboxConstants.SELECT_RECENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     수신함 증명서제출 전자지갑주소검색
     **********/
    case certboxConstants.WALLET_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.WALLET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        walletList: action.response.data?.payload,
      }
    case certboxConstants.WALLET_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     수신함 증명서제출 전자지갑이름검색
     **********/
    case certboxConstants.WALLET_NAME_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.WALLET_NAME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        walletName: action.response.data?.payload ? action.response.data?.payload : false,
      }
    case certboxConstants.WALLET_NAME_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /***********
     증명서 제출 전자지갑 리스트 초기화
     ************/
    case certboxConstants.RESET_RECEIVER:
      return {
        ...state,
        receiverList: [],
        walletList: [],
      }

    /*********
     수신함 구매확인서 상세조회
     **********/
    case certboxConstants.PCRL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.PCRL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pcrlInfo: action.response.data?.payload,
      }
    case certboxConstants.PCRL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     수신함 간접수출실적 상세조회
     **********/
    case certboxConstants.CRTF_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.CRTF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        crtfInfo: action.response.data?.payload,
      }
    case certboxConstants.CRTF_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /*********
     증명서 제출
     **********/
    case certboxConstants.SUBMIT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmission: true,
      }
    case certboxConstants.SUBMIT_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /*********
     증명서 업로드
     **********/
    case certboxConstants.UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.UPLOAD_SUCCESS:
      return {
        ...state,
        isUpload: true,
      }
    case certboxConstants.UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /*********
     증명서 1회열람
     **********/
    case certboxConstants.READING_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.READING_SUCCESS:
      return {
        ...state,
        isReading: true,
        readingInfo: action.response.data?.payload,
      }
    case certboxConstants.READING_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /*********
     증명서 반려
     **********/
    case certboxConstants.REJECT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.REJECT_SUCCESS:
      return {
        ...state,
        isReject: true,
      }
    case certboxConstants.REJECT_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    /*********
     증명서 1회열람 확인
     **********/
    case certboxConstants.READING_COMPLETION_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.READING_COMPLETION_SUCCESS:
      return {
        ...state,
        isReading: true,
      }
    case certboxConstants.READING_COMPLETION_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case certboxConstants.SHOW_PWD_POPUP:
      return {
        ...state,
        showPwdPopup: action.isShow,
        certbox: action.certbox,
      }

    /***********
     증명서 수신함 히스토리 관리
     ************/
    case certboxConstants.CERTBOX_HISTORY:
      return {
        ...state,
        history: action.payload,
      }

    /*********
     증명서 PDF BASE64STRING 조회
     **********/
    case certboxConstants.PDF_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case certboxConstants.PDF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdfString: action.response.data,
      }
    case certboxConstants.PDF_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /***********
     PDF 호출 init 처리
     ************/
    case certboxConstants.INIT_FLAG_REQUEST:
      return {
        ...state,
        pdfString: null,
      }

    /***********
     상태관련 state 초기화
     ************/
    case certboxConstants.CLEAR_REQUEST:
      return {
        ...state,
        isFailure: false,
        isDelete: false,
        isSubmit: false,
        isSubmission: false,
      }

    /*********
     증명서 첨부파일 다운로드
     **********/
    case certboxConstants.FILE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFile: true,
      }
    case certboxConstants.FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFile: false,
      }

    /***********
   수신함 PDF 발급요청
     ************/
    case certboxConstants.SUB_SENT_DOC_PDF_REQUEST:
      return {
        ...state,
      }
    case certboxConstants.SUB_SENT_DOC_PDF_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSubDoc: true,
      }
    case certboxConstants.SUB_SENT_DOC_PDF_FAILURE:
      return {
        ...state,
        isFailure: true,
      }

    /*********
   증명서 수취완료
     **********/
    case certboxConstants.RECEIVE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.RECEIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isReceive: true,
      }
    case certboxConstants.RECEIVE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isReceive: false,
      }

    /*********
     증명서 EDMS TOKEN 확인
     **********/
    case certboxConstants.EDMS_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.EDMS_TOKEN_SUCCESS:
      return {
        ...state,
        tokenInfo: action.response.data?.payload,
        isLoading: false,
        isToken: true,
      }
    case certboxConstants.EDMS_TOKEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isToken: false,
      }

    /*********
     증명서 EDMS 첨부파일 다운로드
     **********/
    case certboxConstants.EDMS_FILE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case certboxConstants.EDMS_FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFile: true,
      }
    case certboxConstants.EDMS_FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFile: false,
      }

    case certboxConstants.SET_EMAIL_TEXT:
      return {
        ...state,
        btnText: '이메일 보내기',
      }
    case certboxConstants.RESET_EMAIL_TEXT:
      return {
        ...state,
        btnText: '',
      }

    case certboxConstants.CERTBOX_CHECKED_DOCS_DOWNLOAD_REQUEST:
      return {
        ...state,
        isCheckedDownloading: !state.isLoading,
      }
    case certboxConstants.CERTBOX_CHECKED_DOCS_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isCheckedDownloading: false,
      }
    case certboxConstants.CERTBOX_CHECKED_DOCS_DOWNLOAD_FAILURE:
      return {
        ...state,
        isCheckedDownloading: false,
      }

    default:
      return state
  }
}
